import React from "react";

const TermsOfService = () => {
  return (
    <div style={{ padding: "40px", maxWidth: "960px", margin: "0 auto" }}>
      <h1>Điều Khoản Sử Dụng</h1>
      <p><strong>Ngày hiệu lực:</strong> 21/08/2025</p>

      <h2>1. Giới thiệu</h2>
      <p>Chào mừng bạn đến với trang web của chúng tôi. Bằng cách truy cập hoặc sử dụng website này, bạn đồng ý tuân thủ các điều khoản sau đây. Nếu bạn không đồng ý với bất kỳ phần nào của các điều khoản này, vui lòng không sử dụng dịch vụ của chúng tôi.</p>

      <h2>2. Quyền sở hữu</h2>
      <p>Tất cả nội dung, thiết kế, mã nguồn và tài sản trí tuệ trên website này thuộc sở hữu của chúng tôi, trừ khi có ghi chú khác. Bạn không được phép sao chép, phân phối, sửa đổi hoặc sử dụng lại mà không có sự cho phép bằng văn bản.</p>

      <h2>3. Trách nhiệm người dùng</h2>
      <p>Bạn cam kết sử dụng dịch vụ đúng mục đích, không gây hại đến hệ thống, không thực hiện các hành vi vi phạm pháp luật hoặc can thiệp vào quyền lợi của người dùng khác.</p>

      <h2>4. Giới hạn trách nhiệm</h2>
      <p>Chúng tôi không chịu trách nhiệm đối với bất kỳ thiệt hại nào phát sinh từ việc sử dụng hoặc không thể sử dụng dịch vụ, kể cả trong trường hợp đã được cảnh báo trước về khả năng xảy ra thiệt hại.</p>

      <h2>5. Thay đổi điều khoản</h2>
      <p>Chúng tôi có thể cập nhật các điều khoản này bất kỳ lúc nào. Thông báo sẽ được công bố trên website. Việc bạn tiếp tục sử dụng sau thay đổi đồng nghĩa với việc bạn chấp nhận điều khoản mới.</p>

      <h2>6. Luật điều chỉnh</h2>
      <p>Các điều khoản này được điều chỉnh bởi pháp luật nước Cộng hòa Xã hội Chủ nghĩa Việt Nam. Mọi tranh chấp phát sinh sẽ được giải quyết tại tòa án có thẩm quyền.</p>

      <p>Xin cảm ơn bạn đã sử dụng dịch vụ của chúng tôi.</p>
    </div>
  );
};

export default TermsOfService;
